import type { LucideIcon } from 'lucide-react'
import * as React from 'react'
import { forwardRef } from 'react'

export const BookRowPremiumBadge: LucideIcon = forwardRef(({ size = 72, ...props }, ref) => {
  return (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox='0 0 72 72'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <g clipPath='url(#clip0_3409_3013)'>
        <g filter='url(#filter0_d_3409_3013)'>
          <path d='M72 72H0L72 0V72Z' fill='url(#paint0_linear_3409_3013)' />
        </g>
        <rect x='36' y='36' width='32' height='32' rx='16' fill='#FFF9E7' />
        <path
          d='M53.2346 39.8561L56.1161 45.9577C56.3284 46.4107 56.7444 46.7232 57.2211 46.7957L63.6602 47.7741C64.8648 47.9553 65.3458 49.5045 64.4748 50.3923L59.8167 55.1395C59.47 55.4928 59.314 56.0001 59.3963 56.4984L60.497 63.2024C60.7006 64.4571 59.444 65.4129 58.365 64.8195L52.6062 61.6532C52.1773 61.4177 51.6659 61.4177 51.2413 61.6532L45.4825 64.8195C44.4035 65.4129 43.1469 64.4571 43.3506 63.2024L44.4512 56.4984C44.5335 56.0001 44.3732 55.4928 44.0309 55.1395L39.364 50.3923C38.4931 49.5045 38.9741 47.9598 40.1787 47.7741L46.6178 46.7957C47.0944 46.7232 47.5104 46.4107 47.7228 45.9577L50.6 39.8561C51.1373 38.7146 52.6929 38.7146 53.2346 39.8561Z'
          fill='url(#paint1_linear_3409_3013)'
        />
        <path
          d='M52.1096 55.6417C53.4705 55.6417 54.5945 54.4912 54.8055 52.9783C54.8443 52.711 54.6548 52.4619 54.3964 52.4619H49.8229C49.5645 52.4619 49.375 52.7065 49.4137 52.9783C49.6248 54.4866 50.7531 55.6417 52.1096 55.6417ZM52.1096 53.3905C52.7341 53.3905 53.238 53.9793 53.238 54.7041H50.9813C50.9813 53.9793 51.4852 53.3905 52.1096 53.3905Z'
          fill='#2C2B2A'
        />
        <path
          d='M53.238 54.7041C53.238 53.9793 52.7341 53.3905 52.1096 53.3905C51.4852 53.3905 50.9813 53.9793 50.9813 54.7041H53.238Z'
          fill='#E73957'
        />
        <path
          d='M48.1042 51.6378C48.5609 51.6378 48.9311 51.2484 48.9311 50.7681C48.9311 50.2878 48.5609 49.8984 48.1042 49.8984C47.6475 49.8984 47.2773 50.2878 47.2773 50.7681C47.2773 51.2484 47.6475 51.6378 48.1042 51.6378Z'
          fill='#2C2B2A'
        />
        <path
          d='M56.1189 51.6378C56.5755 51.6378 56.9457 51.2484 56.9457 50.7681C56.9457 50.2878 56.5755 49.8984 56.1189 49.8984C55.6622 49.8984 55.292 50.2878 55.292 50.7681C55.292 51.2484 55.6622 51.6378 56.1189 51.6378Z'
          fill='#2C2B2A'
        />
      </g>
      <defs>
        <filter
          id='filter0_d_3409_3013'
          x='-4'
          y='-8'
          width='80'
          height='80'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dy='-4' />
          <feGaussianBlur stdDeviation='2' />
          <feComposite in2='hardAlpha' operator='out' />
          <feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0' />
          <feBlend mode='normal' in2='BackgroundImageFix' result='effect1_dropShadow_3409_3013' />
          <feBlend mode='normal' in='SourceGraphic' in2='effect1_dropShadow_3409_3013' result='shape' />
        </filter>
        <linearGradient
          id='paint0_linear_3409_3013'
          x1='24.2542'
          y1='-18.8572'
          x2='63.6648'
          y2='-7.47122'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#FF7621' />
          <stop offset='0.97' stopColor='#E73957' />
        </linearGradient>
        <linearGradient
          id='paint1_linear_3409_3013'
          x1='60.0002'
          y1='36.5'
          x2='69.0796'
          y2='52.3123'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#FDE590' />
          <stop offset='0.93' stopColor='#FFA800' />
        </linearGradient>
        <clipPath id='clip0_3409_3013'>
          <rect width='72' height='72' fill='white' />
        </clipPath>
      </defs>
    </svg>
  )
})

BookRowPremiumBadge.displayName = 'BookRowPremiumBadge'
